module.exports = __webpack_public_path__ + "static/media/purchaseOption-paperbackStory.a0fb5f19.svg";